const styles = {
  featureItem: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '8px',
    color: 'kit.text.h',
  },
  icon_dark: {
    color: 'inherit',
  },
  icon_default: {
    color: 'kit.background.black',
  },
  text_default: {
    color: 'kit.text.main',
  },
  text_orange: {
    color: 'kit.infographic.orange',
  },
};

export default styles;
